export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13252.72c3a58a.jpg";